import type { DataValue, SourceValue } from '../sources';
import { applyFilters } from './applyFilters';
import { mapFilters } from './mapFilters';

export const createFiltersFn =
  ({ filters }: SourceValue, availableFilters: string[]) =>
  (data: DataValue[]) => {
    if (!filters) {
      return data;
    }

    const filtersList = mapFilters(filters, availableFilters);

    return data.filter(({ source, text, timestamp, user, repost }) => {
      const { url } = source;
      const { name = '', username = '' } = user ?? {};
      const { text: repostText } = repost ?? {};
      const mergedText = repostText ? `${text} ${repostText}` : text;

      return applyFilters(filtersList, {
        creationTimestamp: timestamp ?? 0,
        username: name || username,
        message: mergedText ?? '',
        postUrl: url
      });
    });
  };
